import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Group from './group';
import Team from './team';

@Model()
export default class TeamGroupAssignment extends ApplicationRecord {
  static jsonapiType = 'team_group_assignments';
  @Attr({ persist: false }) selected: boolean;

  @BelongsTo() team: Team;
  @BelongsTo() group: Group;

  constructor(attrs?: Record<string, any>) {
    super(attrs);
    this.selected = false;
  }
}
